import React from 'react'
import TextSecondaryNoUnderline from 'app/components/TextSecondaryNoUnderline'
import { Typography } from '@material-ui/core'
import * as R from 'ramda'
import { FormattedMessage } from 'react-intl'

const EmptyVoucherOption = ({
  styleClass,
  formatMessage,
  vouchers,
  onOpenVoucherFormDialog,
}) => {
  return (
    <div className="p-16 flex flex-col">
      {vouchers && R.isEmpty(vouchers) && (
        <Typography varient="subtitle" className="text-gray-500">
          {formatMessage({
            id: 'dealsPromotions.attach.select.empty',
          })}
        </Typography>
      )}
      <div
        className={styleClass.linkCreateVoucher}
        onClick={onOpenVoucherFormDialog}
      >
        <TextSecondaryNoUnderline>
          <FormattedMessage id="dealsPromotions.attach.select.button.create" />
        </TextSecondaryNoUnderline>
      </div>
    </div>
  )
}

export default EmptyVoucherOption
